import TextField from "@/components/layouts/History/TextField";
import { useSubIndustries } from "@/entities/settings/hooks";

interface Props {
  value: string;
}

const SubIndustryName: React.FC<Props> = ({ value }) => {
  const subIndustries = useSubIndustries().data ?? [];

  const subIndustry = subIndustries.find(
    (subIndustry) => subIndustry.id === value
  );

  return <TextField>{subIndustry?.name ?? value}</TextField>;
};

export default SubIndustryName;
